import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styled from '../../styles/styled';
import Theme from '../../styles/theme';
import { Toast } from '../toast/toast';
const TOAST_ANIMATION_SPEED = 300;
export const Toaster = ({ content, onClose, onPauseToastTimeout, onResumeToastTimeout, }) => {
    const nodeRef = useRef(null);
    return (_jsx(ToasterWrapper, { children: content.map(toast => {
            return (_jsx(CSSTransition, { nodeRef: nodeRef, timeout: TOAST_ANIMATION_SPEED - 10, children: _jsx(Toast, { flavor: toast.flavor, onClose: () => onClose(toast.id), id: toast.id, onPauseToastTimeout: toast.manualClose ? null : () => onPauseToastTimeout(toast.id), onResumeToastTimeout: toast.manualClose
                        ? null
                        : () => onResumeToastTimeout(toast.id, toast?.timeout), children: toast.content }, `toast-${toast.id}`) }, toast.id));
        }) }));
};
const ToasterWrapper = styled(TransitionGroup)({
    display: 'grid',
    gridGap: '16px',
    position: 'fixed',
    bottom: '40px',
    right: '40px',
    zIndex: Theme.layers.notification,
    '.enter': {
        animation: `${Theme.keyframes.slideLeft} ${TOAST_ANIMATION_SPEED}ms linear infinite`,
        animationIterationCount: 1,
    },
    '.exit': {
        animation: `${Theme.keyframes.slideLeft} ${TOAST_ANIMATION_SPEED}ms linear infinite`,
        animationIterationCount: 1,
        animationDirection: 'reverse',
    },
});
//# sourceMappingURL=toaster.js.map